import { createI18n } from 'vue-i18n';
import modulesMessages from './messages';
import { configs } from '@/v2/system-configs';

const i18n = createI18n({
	locale: localStorage.getItem('lang') || 'en',
	fallbackLocale: 'ar',
	legacy: false,
	messages: loadLocaleMessages(),
});

export default i18n;

export const t = i18n.global.t;

function loadLocaleMessages() {
	const locales = require.context('./', true, /[A-Za-z0-9-_,\s]+\.json$/i);
	const messages = {};
	locales.keys().forEach((key) => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i);
		if (matched && matched.length > 1) {
			const locale = matched[1];
			messages[locale] = locales(key);
		}
	});
	Object.keys(modulesMessages).forEach((moduleName) => {
		Object.keys(modulesMessages[moduleName]).forEach((locale) => {
			if (messages[locale][moduleName]) {
				messages[locale][moduleName] = {
					...messages[locale][moduleName],
					...modulesMessages[moduleName][locale],
				};
			} else {
				messages[locale][moduleName] = {
					...modulesMessages[moduleName][locale],
				};
			}
		});
	});
	messages['en']['brand-name'] = configs.name.en;
	messages['ar']['brand-name'] = configs.name.ar;
	return messages;
}
